import { createChannel } from "APP_ROOT/cable";
import api from "APP_ROOT/api";
import { SETTINGS } from "APP_ROOT/constants";
import { SET_SETTINGS } from "MODULES/session/actionTypes";
import { get } from "lodash";

let channel = null;

export function unsubscribe() {
  if (channel) {
    channel.unsubscribe();
    channel = null;
  }
}

export function onDisconnect() {
  return unsubscribe();
}

export function refreshAppSettings() {
  return dispatch =>
    api.locations.search().then(({ data }) => {
      const locations = data.results;
      api.appSetting.index().then(response => {
        dispatch({
          type: SET_SETTINGS,
          settings: get(response.data, SETTINGS),
          locations
        });
      });
    });
}

export function subscribe() {
  return dispatch =>
    createChannel().listen("SessionChannel", {
      onDisconnect,
      onReceive: () => {
        dispatch(refreshAppSettings());
      }
    });
}



// WEBPACK FOOTER //
// ./app/modules/Admin/sessionChannel.js